import { Controller } from "@hotwired/stimulus";

export default class {
  static trigger(message) {
    let id = Math.random().toString(36).substring(7);
    const template = `
 <div style="z-index:9999" aria-live="assertive" class="pointer-events-none transition-all transition-duration-900 absolute z-100 flex items-center justify-end px-4 py-6 sm:p-6 top-0 right-0 left-0 w-full animate-toast-from-right" data-controller="railsui-toast"
data-railsui-toast-trigger-on-load-value="true"
id="${id}"
>
    <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 dark:bg-zinc-950 dark:border dark:border-zinc-700/80">
      <div class="p-4">
        <div class="flex items-start">
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-zinc-900 dark:text-white">TITLE</p>
            <p class="mt-1 text-sm text-zinc-500 dark:text-zinc-300">MESSAGE</p>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

    document.body.insertAdjacentHTML(
      "beforeend",
      template
        .replace("TITLE", message.title)
        .replace("MESSAGE", message.message),
    );

    setTimeout(() => {
      document.getElementById(id).classList.add("opacity-0");
      document.getElementById(id).remove();
    }, 6000);
  }
}
